export default __webpack_public_path__ + "static/media/Alan.7cc9495f.jpg";